import {ReactNode} from 'react';

import {IContentProps} from '../Content/IContent';

export enum EContentCardStyle {
	Default = 'default',
	'Content Above Image' = 'above-image',
	'Review' = 'review',
	'Service Card' = 'service-card',
	'Product Push' = 'product-push',
	'Preview Image' = 'preview-image',
}

type TTarget = {
	props?: TTarget;
	targetUrl?: string;
	targetPage?: {
		slug?: string;
	};
	targetCategory?: string;
};

export interface IContentCardContentfulProps extends Omit<IContentProps, 'data'> {
	imagesCollection: {
		reactElements?: ReactNode;
		items: {image: object}[];
	};
	subtitlesCollection: {
		reactElements?: ReactNode;
		items: object[];
	};
	title: string;
	description?: string;
	target: TTarget;
	linksCollection: {
		reactElements?: ReactNode;
		items: object[];
	};
	style?: EContentCardStyle;
	classNames?: string;
}
